import { trpc, useMutation } from '@faceup/trpc'
import { Card } from '@faceup/ui'
import { Alert, Button, Popconfirm, useMessage } from '@faceup/ui-base'

export const RouteAiHotlineNumbersCard = () => {
  const message = useMessage()
  const {
    mutate: routeNumbers,
    data,
    isPending,
  } = useMutation(
    trpc.aiHotline.routeNumbersToRegionalSipServer.mutationOptions({
      onSuccess: ({ repointedPhoneNumbers }) => {
        message.success(`Routed ${repointedPhoneNumbers.length} AI hotline numbers`)
      },
    })
  )

  return (
    <Card>
      <Card.Header>Route AI hotline numbers to this region&apos;s SIP server</Card.Header>
      <Card.Content>
        <p className='mb-4 text-colorTextSecondary'>
          Run once in every region after its SIP server goes live. Points every AI hotline number of
          the region you are connected to at that region&apos;s SIP server in Vonage. Safe to
          repeat.
        </p>
        {data && data.failedPhoneNumbers.length > 0 && (
          <Alert
            className='mb-4'
            type='error'
            message={`Could not route: ${data.failedPhoneNumbers.join(', ')}`}
          />
        )}
        <Popconfirm
          title='Route every AI hotline number of this region to its SIP server?'
          onConfirm={() => routeNumbers()}
        >
          <Button loading={isPending}>Route numbers</Button>
        </Popconfirm>
      </Card.Content>
    </Card>
  )
}
